/**
 * SVG 精密战术准星（Corner Reticles）。
 * 用矢量刻度替代 CSS border，为透镜容器提供「仪器感」边角。
 */
export function CornerReticles({
  className = '',
  color = 'rgba(255,255,255,0.38)',
  inset = 12,
}: {
  className?: string;
  color?: string;
  inset?: number;
}) {
  const corner = (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <path d="M0.5 4V0.5H4" stroke={color} strokeWidth="1.1" strokeLinecap="square" />
    </svg>
  );
  return (
    <div className={`pointer-events-none absolute inset-0 z-[2] ${className}`} aria-hidden="true">
      <span style={{ position: 'absolute', top: inset, left: inset }}>{corner}</span>
      <span style={{ position: 'absolute', top: inset, right: inset, transform: 'scaleX(-1)' }}>{corner}</span>
      <span style={{ position: 'absolute', bottom: inset, left: inset, transform: 'scaleY(-1)' }}>{corner}</span>
      <span
        style={{ position: 'absolute', bottom: inset, right: inset, transform: 'scale(-1, -1)' }}
      >
        {corner}
      </span>
    </div>
  );
}

/** 顶部刻度尺：为计时器/卡片提供 1px 精密刻度，纯 SVG。 */
export function EdgeRuler({
  count = 24,
  className = '',
  color = 'rgba(255,255,255,0.22)',
}: {
  count?: number;
  className?: string;
  color?: string;
}) {
  return (
    <svg
      className={`pointer-events-none ${className}`}
      height="6"
      width="100%"
      preserveAspectRatio="none"
      viewBox={`0 0 ${count * 4} 6`}
      aria-hidden="true"
    >
      {Array.from({ length: count + 1 }, (_, index) => {
        const tall = index % 6 === 0;
        return (
          <line
            key={index}
            x1={index * 4 + 0.5}
            y1={0}
            x2={index * 4 + 0.5}
            y2={tall ? 6 : 3}
            stroke={color}
            strokeWidth="1"
          />
        );
      })}
    </svg>
  );
}
